import { Layout, Row, ConfigProvider } from 'antd'
import styled from 'styled-components'

import Profile from './components/profile'
import Pages from './components/pages'

const { Content, Footer } = Layout

const Container = styled(Content)`
  max-width: 88%;
  margin: 0 auto;

  @media only screen and (max-width: 1024px) {
    max-width: 98%;
  }

  @media only screen and (max-width: 768px) {
    max-width: 96%;
  }
`

const currentYear = new Date().getFullYear()

export default function App() {
  return (
    <ConfigProvider theme={{ token: { borderRadius: 2 } }}>
      <Container>
        <Content>
          <br />
          <br />
          <Row gutter={16}>
            <Profile />
            <Pages />
          </Row>
          <br />
          <br />
        </Content>
        <Footer style={{ textAlign: 'center', background: 'transparent' }}>
          PATARA TRIRAT &copy; {currentYear}
        </Footer>
        <br />
      </Container>
    </ConfigProvider>
  )
}
